import MiniSearch from 'minisearch'

import { UniversalSearchStaticItem, UniversalSearchStaticResult } from './types'

const searchableFields = ['title', 'subtitle', 'group', 'keywords']

export function searchStaticItems(
    items: readonly UniversalSearchStaticItem[],
    query: string,
): UniversalSearchStaticResult[] {
    const normalizedQuery = query.trim()
    if (!normalizedQuery) return []

    const itemsById = Object.fromEntries(items.map(item => [item.id, item]))

    const miniSearch = new MiniSearch<UniversalSearchStaticItem>({
        fields: searchableFields,
        storeFields: ['id'],
        searchOptions: {
            boost: { title: 4, keywords: 2, subtitle: 1.5 },
            fuzzy: 0.2,
            prefix: true,
        },
        extractField: (document, fieldName) => {
            const value = document[fieldName as keyof UniversalSearchStaticItem]
            if (Array.isArray(value)) return value.join(' ')
            if (typeof value === 'string') return value
            return ''
        },
    })

    miniSearch.addAll([...items])

    return miniSearch
        .search(normalizedQuery)
        .map(result => {
            const item = itemsById[String(result.id)]
            if (!item) return undefined
            return {
                ...item,
                score: result.score,
            }
        })
        .filter(Boolean) as UniversalSearchStaticResult[]
}
